export default __webpack_public_path__ + "static/media/rt-team-bg.2f619379.jpg";